import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';
import { ICodigoSegContribuinte } from '../model/csc.model';

@Injectable()
export class CodigoSegContribuinteService extends EntityService<
  ICodigoSegContribuinte
> {
  constructor(protected configService: ConfigService) {
    super({
      baseEntityEndPoint: 'codigo_seguranca_contribuinte',
      urlBackend: configService.backendURL
    });
  }
}
